import { FinancialsKpisActionTypes } from './constants';
import { PAGINATION_DEFAULT_VALUE } from '../../helpers/defaultValue';

export const INIT_STATE = {
    errorGetCharges: null,
    loadingCharges: false,
    charges: null,
    chargesPagination: PAGINATION_DEFAULT_VALUE,
    errorGetAdjustments: null,
    loadingAdjustments: false,
    adjustments: null,
    adjustmentsPagination: PAGINATION_DEFAULT_VALUE,
    errorGetAdjustmentsReport: null,
    loadingAdjustmentsReport: false,
    adjustmentsReport: null,
    errorGetCustomAdjustments: null,
    loadingCustomAdjustments: false,
    customAdjustments: null,
    customAdjustmentsPagination: PAGINATION_DEFAULT_VALUE,
    errorGetCustomAdjustmentsReport: null,
    loadingCustomAdjustmentsReport: false,
    customAdjustmentsReport: null,
    errorGetMargins: null,
    loadingMargins: false,
    margins: null,
    marginsPagination: PAGINATION_DEFAULT_VALUE,
    errorGetMarginsReport: null,
    loadingMarginsReport: false,
    marginsReport: null,
    errorGetVerifiedMargins: null,
    loadingVerifiedMargins: false,
    verifiedMargins: null,
    verifiedMarginsPagination: PAGINATION_DEFAULT_VALUE,
    errorGetVerifiedMarginsReport: null,
    loadingVerifiedMarginsReport: false,
    verifiedMarginsReport: null,
};

type FinancialsKpisAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

//TODO: define data type for shipment financial analytics
type State = {
    errorGetCharges?: null,
    loadingCharges: Boolean,
    charges: any,
    chargesPagination: any,
    errorGetAdjustments?: null,
    loadingAdjustments: Boolean,
    adjustments: any,
    adjustmentsPagination: any,
    errorGetAdjustmentsReport: null,
    loadingAdjustmentsReport: Boolean,
    adjustmentsReport: any,
    errorGetCustomAdjustments: null,
    loadingCustomAdjustments: Boolean,
    customAdjustments: any,
    customAdjustmentsPagination: any,
    errorGetCustomAdjustmentsReport: null,
    loadingCustomAdjustmentsReport: Boolean,
    customAdjustmentsReport: any,
    errorGetMargins: null,
    loadingMargins: Boolean,
    margins: any,
    marginsPagination: any,
    errorGetMarginsReport: null,
    loadingMarginsReport: Boolean,
    marginsReport: any,
    errorGetVerifiedMargins: null,
    loadingVerifiedMargins: Boolean,
    verifiedMargins: any,
    verifiedMarginsPagination: any,
    errorGetVerifiedMarginsReport: null,
    loadingVerifiedMarginsReport: Boolean,
    verifiedMarginsReport: any,
};

const FinancialsKpis = (state: State = INIT_STATE, action: FinancialsKpisAction): any => {
    switch (action.type) {
        case FinancialsKpisActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case FinancialsKpisActionTypes.GET_CHARGES: {
                    return { 
                        ...state, 
                        loadingCharges: false, 
                        charges: action.payload.charges, 
                        chargesPagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.pagination }
                    };
                }
                case FinancialsKpisActionTypes.GET_ADJUSTMENTS: {
                    return { 
                        ...state, 
                        loadingAdjustments: false, 
                        adjustments: action.payload.data.adjustments, 
                        adjustmentsPagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.data.pagination }
                    };
                }
                case FinancialsKpisActionTypes.GET_ADJUSTMENTS_REPORT: {
                    return {
                        ...state,
                        loadingAdjustmentsReport: false,
                        adjustmentsReport: action.payload.data.adjustmentsReport,
                    };
                }
                case FinancialsKpisActionTypes.GET_CUSTOM_ADJUSTMENTS: {
                    return {
                        ...state,
                        loadingCustomAdjustments: false,
                        customAdjustments: action.payload.data.customAdjustments,
                        customAdjustmentsPagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.data.pagination }
                    };
                }
                case FinancialsKpisActionTypes.GET_CUSTOM_ADJUSTMENTS_REPORT: {
                    return {
                        ...state,
                        loadingCustomAdjustmentsReport: false,
                        customAdjustmentsReport: action.payload.data.customAdjustmentsReport,
                    };
                }
                case FinancialsKpisActionTypes.GET_MARGINS: {
                    return { 
                        ...state, 
                        loadingMargins: false, 
                        margins: action.payload.data.margins, 
                        marginsPagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.data.pagination }
                    };
                }
                case FinancialsKpisActionTypes.GET_MARGINS_REPORT: {
                    return {
                        ...state,
                        loadingMarginsReport: false,
                        marginsReport: action.payload.data.marginsReport,
                    };
                }
                case FinancialsKpisActionTypes.GET_VERIFIED_MARGINS: {
                    return {
                        ...state,
                        loadingVerifiedMargins: false,
                        verifiedMargins: action.payload.data.verifiedMargins,
                        verifiedMarginsPagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.data.pagination }
                    };
                }
                case FinancialsKpisActionTypes.GET_VERIFIED_MARGINS_REPORT: {
                    return {
                        ...state,
                        loadingVerifiedMarginsReport: false,
                        verifiedMarginsReport: action.payload.data.verifiedMarginsReport,
                    };
                }
                default:
                    return { 
                        ...state, 
                        loadingCharges: false, 
                        loadingAdjustments: false, 
                        loadingAdjustmentsReport: false, 
                        loadingMargins: false, 
                        loadingMarginsReport: false, 
                        loadingVerifiedMargins: false, 
                        loadingVerifiedMarginsReport: false, 
                        loadingCustomAdjustments: false, 
                        loadingCustomAdjustmentsReport: false 
                    };
            }

        case FinancialsKpisActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case FinancialsKpisActionTypes.GET_CHARGES: {
                    return { ...state, loadingCharges: false, errorGetCharges: action.payload.error };
                }
                case FinancialsKpisActionTypes.GET_ADJUSTMENTS: {
                    return { ...state, loadingAdjustments: false, errorGetAdjustments: action.payload.error };
                }
                case FinancialsKpisActionTypes.GET_ADJUSTMENTS_REPORT: {
                    return { ...state, loadingAdjustmentsReport: false, errorGetAdjustmentsReport: action.payload.error };
                }
                case FinancialsKpisActionTypes.GET_CUSTOM_ADJUSTMENTS: {
                    return { ...state, loadingCustomAdjustments: false, errorGetCustomAdjustments: action.payload.error };
                }
                case FinancialsKpisActionTypes.GET_CUSTOM_ADJUSTMENTS_REPORT: {
                    return { ...state, loadingCustomAdjustmentsReport: false, errorGetCustomAdjustmentsReport: action.payload.error };
                }
                case FinancialsKpisActionTypes.GET_MARGINS: {
                    return { ...state, loadingMargins: false, errorGetMargins: action.payload.error };
                }
                case FinancialsKpisActionTypes.GET_VERIFIED_MARGINS: {
                    return { ...state, loadingVerifiedMargins: false, errorGetVerifiedMargins: action.payload.error };
                }
                case FinancialsKpisActionTypes.GET_MARGINS_REPORT: {
                    return { ...state, loadingMarginsReport: false, errorGetMarginsReport: action.payload.error };
                }
                case FinancialsKpisActionTypes.GET_VERIFIED_MARGINS_REPORT: {
                    return { ...state, loadingVerifiedMarginsReport: false, errorGetVerifiedMarginsReport: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case FinancialsKpisActionTypes.GET_CHARGES:
            return { ...state, loadingCharges: true, charges: null };
        case FinancialsKpisActionTypes.GET_ADJUSTMENTS:
            return { ...state, loadingAdjustments: true, adjustments: null };
        case FinancialsKpisActionTypes.GET_ADJUSTMENTS_REPORT: {
            return { ...state, loadingAdjustmentsReport: true, adjustmentsReport: null };
        }
        case FinancialsKpisActionTypes.GET_CUSTOM_ADJUSTMENTS: {
            return { ...state, loadingCustomAdjustments: true, customAdjustments: null };
        }
        case FinancialsKpisActionTypes.GET_CUSTOM_ADJUSTMENTS_REPORT: {
            return { ...state, loadingCustomAdjustmentsReport: true, customAdjustmentsReport: null };
        }
        case FinancialsKpisActionTypes.GET_MARGINS:
            return { ...state, loadingMargins: true, margins: null };
        case FinancialsKpisActionTypes.GET_MARGINS_REPORT: {
            return { ...state, loadingMarginsReport: true, marginsReport: null };
        }
        case FinancialsKpisActionTypes.GET_VERIFIED_MARGINS:
            return { ...state, loadingVerifiedMargins: true, verifiedMargins: null };
        case FinancialsKpisActionTypes.GET_VERIFIED_MARGINS_REPORT: {
            return { ...state, loadingVerifiedMarginsReport: true, verifiedMarginsReport: null };
        }
        case FinancialsKpisActionTypes.RESET_STATE:
            return { ...INIT_STATE };
        default:
            return { ...state };
    }
};

export default FinancialsKpis;
